import { isRoleForCompany } from "features/invoice-approvals/invoice-approvals.slice";

const ASSET_REQUEST_PERMISSIONS = ["Master", "Access assets"];

type RoleLike = { permissionsgroups?: string[] | null; company?: string | null } | null | undefined;

/** True when this role may read the queue of requests (Turtas → «Prašymai»). */
export function canSeeAssetRequestsFor(role: RoleLike, companyId?: string | null): boolean {
  if (!isRoleForCompany(role, companyId)) return false;
  const groups = role?.permissionsgroups || [];
  return ASSET_REQUEST_PERMISSIONS.some((permission) => groups.includes(permission));
}
